import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  container: {
    position: 'relative',
    padding: 0
  },
  fixedButtonContainer: {
    position: 'fixed',
    top: theme.sizes.headerHeight + 40,
    left: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  icon: {
    height: 48,
    width: 48
  },
  iconImg: {
    transform: 'rotate(180deg)'
  },
  navigatorIconImg: {
    height: 40,
    width: 40,
    transform: 'rotate(180deg)'
  },
  copyButton: {
    padding: theme.spacing(3),
    borderRadius: '50%'
  },
  rightLabel: {
    fontSize: 14,
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  rightValue: {
    fontSize: 14,
    display: 'inline'
  },
  rightContainer: {
    padding: 0
  },
  link: {
    fontWeight: 500,
    // The global `a` rule sets display: contents, which leaves no box to draw the hover underline on
    display: 'inline',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

export default makeStyles(styles);
